import { NotImplementedError } from "../../../../../errors";
import { parseDateFilter } from "../../../../../models/looker/modules/inventory";
import { PromiseHandler } from "../../../../../handlers";
import { FILTER_OPTIONS_ADVERTISER_QUERY } from "../query";
export default class LookerInventoryAdvertiserFilter extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-inventory-advertiser-filter");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const parsedDateFilter = parseDateFilter(dateFilter);
        const queryBody = {
            ...FILTER_OPTIONS_ADVERTISER_QUERY,
            filters: {
                "billable_agg.filter_date_nyc": parsedDateFilter
            }
        };
        // Add publisher filter if provided
        const publisherFilter = filters.where?.find((filter) => filter.field === "publisherIds");
        if (publisherFilter) {
            queryBody.filters["billable_agg.publisher_id"] = publisherFilter.value.join(",");
        }
        // Add campaign filter if provided
        const campaignFilter = filters.where?.find((filter) => filter.field === "campaignIds");
        if (campaignFilter) {
            queryBody.filters["conversion_meta_inst.campaign__id"] = campaignFilter.value.join(",");
        }
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatAdvertiserResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch inventory dashboard advertiser filter options");
        }));
    }
    formatAdvertiserResponse(data) {
        return data.map((advertiser) => ({
            name: advertiser["conversion_meta_inst.advertiser__name"],
            id: advertiser["conversion_meta_inst.advertiser__id"]
        }));
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=Advertiser.js.map